import analytics from "./api";

const trackingMiddleware = store => next => action => {
  if (!action.meta || !action.meta.analytics) {
    return next(action);
  }

  const { name, section, title } = action.meta.analytics;

  analytics.track(name, section, title);

  return next(action);
};

export default trackingMiddleware;



// WEBPACK FOOTER //
// ./src/services/analytics/middleware.js